export default {"src":"/_next/static/media/onboarding1.e32f160a.svg","height":434,"width":399,"blurWidth":0,"blurHeight":0};